<p>
  success-dialog works!
</p>
